import type { ServerError } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'

import errorHandler from '@/helpers/errorHandlerUtility'
import { redirectToLogin } from '@/helpers/loginHelper'
import { resetAllStores, useLocaleStore } from '@/stores'

// Dynamic-import @/router to break a module-init cycle:
// @/router eagerly imports @/components → @/services/roles → @/policies/BoothPolicy,
// and policies → @/stores → @/plugins/vue-apollo → this file. Loading router lazily
// keeps the redirect behavior intact (it's only needed when an error actually fires).
const loadRouter = () => import('@/router').then((m) => m.default)

const link = onError(({ graphQLErrors, networkError }) => {
  const localeStore = useLocaleStore()

  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => {
      if (message === 'User not authorized') {
        resetAllStores()
        redirectToLogin(localeStore.locale)
        return
      }
      errorHandler.report(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    })
  }

  if (networkError && (networkError as ServerError).statusCode) {
    const code = (networkError as ServerError).statusCode
    errorHandler.report(networkError.message)

    if (code === 401) {
      resetAllStores()
      redirectToLogin(localeStore.locale)
    } else if (code === 404) {
      void loadRouter().then((router) => router.push({ name: '404' }))
    } else {
      void loadRouter().then((router) => {
        if (router.currentRoute.value.name !== 'network-issue') router.push({ name: 'network-issue' })
      })
    }
  }
})

export default link
